import { render } from "./Resumen.vue?vue&type=template&id=3f81de10&scoped=true"
import script from "./Resumen.vue?vue&type=script&lang=js"
export * from "./Resumen.vue?vue&type=script&lang=js"

import "./Resumen.vue?vue&type=style&index=0&id=3f81de10&scoped=true&lang=css"

import exportComponent from "C:\\development\\ON\\montalvo.ti\\dish-frontend-web-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f81de10"]])

export default __exports__